export default __webpack_public_path__ + "static/media/changepwd-success.0ace74fa.svg";